import React from "react";

import ModalBase from "./ModalBase";
import UploadGraphContent from "../Admin/UploadGraphContent";

interface GraphPreviewerModalProps {
  /** Provided by ModalGlobal — closes the modal. */
  onClose: (result?: any) => void;
}

// The old /home/admin/graph-previewer page as a modal — upload a JSON file to preview it as a graph
const GraphPreviewerModal: React.FC<GraphPreviewerModalProps> = ({ onClose }) => (
  <ModalBase title="Graph Previewer" onClose={() => onClose()} size="lg" fillHeight>
    <p className="mb-4 font-inter text-eai-body-sm text-eai-ink-muted">
      Upload a JSON file to preview it as a graph.
    </p>
    <UploadGraphContent />
  </ModalBase>
);

export default GraphPreviewerModal;
